(function () {

    var errors = false;
    const contactForms = document.getElementsByClassName("contactform")

    if (contactForms && contactForms.length) {

        const contactForm = contactForms[0]
        const errorElements = contactForm.getElementsByClassName("input-validation-error");

        const sent = contactForm.getElementsByClassName("sent").length > 0

        if (errorElements.length > 0 || sent > 0) {
            element = contactForm.closest(".grid__item__container")
            const topPosition = element.getBoundingClientRect().top + window.scrollY - 100;
            window.scrollTo({
                top: topPosition,
                behavior: 'smooth'
            });
        }


    }
})();